/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:17:40
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2023-08-18 15:02:17
 * @FilePath: \client-h5\src\pages\transfer\index.jsx
 */
import React, { Component } from 'react';
import {
    Toast,
    DotLoading,
    Button
} from 'antd-mobile';
import './index.scss'
import { getOpenId,getToken } from "../../utils/api"; 
import { host } from "../../utils/util";
import wx from 'weixin-js-sdk';

class Transfer extends Component {
    ref = React.createRef();
    formRef = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            logo: require('../../assets/logo.png'),
            loginStatus:false,
            openId:''
        }
    }

    componentDidMount() {
        
        // this.getOpenIdFn()
        // if (!(window.localStorage.getItem('isLogin'))) {
        //     document.title = '趣智预付费';
        //     this.setState({
        //         loginStatus:false,
        //     })
            
        //     return;
        // }
        // document.title = '加载中...';
        // this.setState({
        //     loginStatus:true,
        // })
    }
    // componentDidMount() {
    //     document.title = '加载中...';
    //     this.setState({
    //         loginStatus:true,
    //     })
    //     this.getToken();
    // }
    // getOpenIdFn = ()=>{
    //     let path = 'http://nb-client-h5.klcxkj-qzxy.cn/transfer';
    //     let appId = 'wx92a2218861683826'
    //     let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURI(path)}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
    //     if(window.location.href.indexOf('code=') != -1){
    //         let code = window.location.search.substring(6,38);
    //         getOpenId({code,state:'state'}).then((res) =>{
    //             if (res.code == '200') {
    //                 if (!(window.localStorage.getItem('isLogin'))) {
    //                     this.setState({
    //                         openId:res.data,
    //                     })
    //                     return;
    //                 }
    //                 this.getToken(res.data);
    //             }else{
    //                 Toast.show({
    //                     content: res.message,
    //                 })
    //             }
                
    //         }).catch((err) =>{
    //             Toast.show({
    //                 content: '系统错误',
    //             })
    //         })
    //     }else{
    //         window.location.href = url
    //     }
    // }
    getOpenIdFn = ()=>{
        if(window.location.href.indexOf('code=') != -1){
            let code = window.location.search.substring(6,38);
            getOpenId({code,state:'state'}).then((res) =>{
                if (res.code == '200') {
                    if (!(window.localStorage.getItem('isLogin'))) {
                        this.setState({
                            openId:res.data,
                        })
                        return;
                    }
                    this.getToken(res.data);
                }else{
                    Toast.show({
                        content: res.message,
                    })
                }
                
            }).catch((err) =>{
                Toast.show({
                    content: '系统错误',
                })
            })
        }
    }
    getToken = (openId)=>{
        getToken({openId}).then((res) =>{
            if (res.access_token !=='') {
                const token = res.access_token
                window.localStorage.setItem('token', token);
                window.localStorage.setItem('isLogin', 1)
                window.location.replace(host+'home')
                // this.props.history.replace('/home')
            }
        }).catch((err) =>{
            if (err.status == '401') {
                window.location.replace(host+'bindTel?openId='+openId)
            }
        })
    }
    wxLogin = ()=>{
        const {openId} = this.state;
        if (openId) {
            this.getToken(openId);
        }else{
            Toast.show({
                content: '请求出错，未获取到openid',
            })
        }
        
    }
    sm=()=>{
        console.log(666);
        wx.scanQRCode({
            needResult: 1,
            scanType: ["qrCode","barCode"],
            success: function (res) {
                var result = res.resultStr;
                alert('扫描结果为：' + result);
            }
        });
    }
    render() {
        const {loginStatus} = this.state;
        return (
            <div className='transfer-container'>
                {/* <div>
                    <img style={{width: '1.2rem', height: '1.2rem'}} src={this.state.logo} />
                </div>
                
                {loginStatus?<div>
                    <DotLoading color='primary' />
                    <div>请稍候</div>
                </div>:
                <div className='tit'>趣智预付费水表</div>
                }
                {!loginStatus&&<div className='wxLogin-box'>
                    <Button color='primary' fill='outline' onClick={this.wxLogin}>微信登录</Button>
                </div>} */}
                <div onClick={this.sm}>扫码</div>
            </div>
        )
    }
}
export default Transfer;

